import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=09e3b3fe&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09e3b3fe')) {
      api.createRecord('09e3b3fe', component.options)
    } else {
      api.reload('09e3b3fe', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=09e3b3fe&", function () {
      api.rerender('09e3b3fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sABbE7qBy3yA/JS/comp/FavElement.vue"
export default component.exports